/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type d'échéance sur laquelle porte la rémunération.
 * @export
 */
export const TypeEcheance = {
    ATerme: 1,
    Comptant: 2,
    LesDeux: 3
} as const;
export type TypeEcheance = typeof TypeEcheance[keyof typeof TypeEcheance];


export function instanceOfTypeEcheance(value: any): boolean {
    for (const key in TypeEcheance) {
        if (Object.prototype.hasOwnProperty.call(TypeEcheance, key)) {
            if (TypeEcheance[key as keyof typeof TypeEcheance] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TypeEcheanceFromJSON(json: any): TypeEcheance {
    return TypeEcheanceFromJSONTyped(json, false);
}

export function TypeEcheanceFromJSONTyped(json: any, ignoreDiscriminator: boolean): TypeEcheance {
    return json as TypeEcheance;
}

export function TypeEcheanceToJSON(value?: TypeEcheance | null): any {
    return value as any;
}

export function TypeEcheanceToJSONTyped(value: any, ignoreDiscriminator: boolean): TypeEcheance {
    return value as TypeEcheance;
}

